module.exports = __webpack_public_path__ + "img/works_left.033cccc8.png";